import { EmptyPageView } from './EmptyPage.view'

export const EmptyPage = () => {
  return <EmptyPageView />
}
